export var containerHeight = 210,
    itemHeight = 32;
/**
 * @desc list of hour times
 * @example 
 * [{
 *    value: 0, 
 *    label: 12:00 am
 * },
 * ...
 * {
 *    value: 24,
 *    label: 11:00 pm
 * }]
 **/

export var TIME_RANGE = Array.from({
  length: 24
}, (_, index) => {
  var label;

  if (index % 12 !== 0) {
    var numberPart = index % 12 + ":00";
    index < 12 ? numberPart += ' am' : numberPart += ' pm';
    label = numberPart;
  } else {
    var _numberPart = 12 + ":00";

    index < 12 ? _numberPart += ' am' : _numberPart += ' pm';
    label = _numberPart;
  }

  return {
    value: index,
    label: label
  };
});
//# sourceMappingURL=consts.js.map